export const Base_URL = `https://api.stockwiseanalytics.com`;
export const Profile_URL = `https://api.stockwiseanalytics.com/uploads`;

